import { arrayOf, func, instanceOf, oneOf } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';

import DiscardableForm from '../../generic/DiscardableForm';
import FileUploader from '../../generic/FileUploader';
import SingleSelect from '../../generic/SingleSelect';
import { optionShape } from '../../prop-types';
import { UploadManager } from '../../REST/upload';
import { ALL_ATTACHMENT_TYPES, OTHER } from '../constants';

/**
 * In contrast to other Forms, the AttachmentForm will always be for new models,
 * and it is partially uncontrolled (because of the file fields).
 */

function fileMetaFields(type) {
  return type === OTHER
    ? [{ id: 'name', name: 'Name', placeholder: 'File name' }]
    : [];
}

function AttachmentForm({
  type,
  uploader,
  onTypeChange,
  onSubmit,
  attachmentTypes,
}) {
  return (
    <DiscardableForm onSubmit={onSubmit}>
      <FormGroup row>
        <Label sm={2} for="at-type">
          Type
        </Label>
        <Col sm={10}>
          <SingleSelect
            options={attachmentTypes}
            id="at-type"
            name="type"
            value={type}
            onChange={onTypeChange}
          />
        </Col>
      </FormGroup>
      <FormGroup>
        <FileUploader
          key={type}
          height="18rem"
          hideUploadButton
          id="at-file"
          manager={uploader}
          metaFields={fileMetaFields(type)}
          name="file"
          note="Select a pdf or spreadsheet…"
        />
      </FormGroup>
    </DiscardableForm>
  );
}

AttachmentForm.propTypes = {
  uploader: instanceOf(UploadManager).isRequired,
  type: oneOf(ALL_ATTACHMENT_TYPES),
  onTypeChange: func.isRequired,
  onSubmit: func.isRequired,
  attachmentTypes: arrayOf(optionShape.isRequired).isRequired,
};

AttachmentForm.defaultProps = {
  type: null,
};

export default AttachmentForm;
